import { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, Clock3 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { ProviderShell } from "@/components/provider/ProviderShell";

const day = (value) => (value ? new Date(`${value.slice(0, 10)}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "No expiration");

const Row = ({ label, status, expires, days, valid, testId }) => {
  const soon = valid && days !== null && days !== undefined && days <= 60;
  const Icon = !valid ? AlertTriangle : soon ? Clock3 : CheckCircle2;
  return (
    <div className={`credential-row ${!valid ? "expired" : soon ? "soon" : "ok"}`} data-testid={testId}>
      <Icon size={18} />
      <div>
        <strong>{label}</strong>
        <span>{status ? `${status} · ` : ""}{!valid ? `Expired ${day(expires)}` : expires ? `Expires ${day(expires)}${soon ? ` · ${days} days` : ""}` : "No expiration"}</span>
      </div>
    </div>
  );
};

export default function ProviderCredentialsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/providers/me/credentials").then((response) => setData(response.data)).catch((requestError) => setError(formatApiError(requestError)));
  }, []);
  return (
    <ProviderShell back="/provider-portal/file" eyebrow="MY FILE" title="Credentials and clearances" testId="provider-credentials-page">
      {error && <p className="form-message error-message" data-testid="provider-credentials-error">{error}</p>}
      {data && (
        <>
          <section className="provider-card" data-testid="provider-credentials-list">
            <p className="eyebrow">LICENSES AND CERTIFICATIONS</p>
            {data.credentials.length === 0 && <span className="muted">Nothing on file yet. TAG adds your licenses here.</span>}
            {data.credentials.map((row) => <Row key={row.id} label={row.credential_type} status={row.document_status} expires={row.expiration_date} days={row.days_remaining} valid={row.valid} testId={`provider-credential-${row.id}`} />)}
          </section>
          <section className="provider-card" data-testid="provider-clearances-list">
            <p className="eyebrow">CLEARANCES AND SCREENINGS</p>
            {data.documents.length === 0 && <span className="muted">Nothing on file yet.</span>}
            {data.documents.map((row) => <Row key={row.id} label={row.document_type} status={row.status} expires={row.expiration_date} days={row.days_remaining} valid={row.valid} testId={`provider-clearance-${row.id}`} />)}
          </section>
          <a className="ghost-button provider-message" data-testid="provider-credentials-message" href="mailto:hr@theallicockgroup.com?subject=Credential%20update">Send TAG an updated document</a>
        </>
      )}
    </ProviderShell>
  );
}
